
import React from 'react';
import { motion } from 'framer-motion';
import { useIsMobile } from '@/hooks/use-mobile';

const companies = [
  {
    name: '4zida.rs',
    url: 'https://www.4zida.rs',
    logo: '/logos/4zida-logo-header.webp',
  },
  {
    name: 'Poslovi Infostud',
    url: 'https://poslovi.infostud.com',
    logo: '/logos/poslovi-infostud.png',
  },
  {
    name: 'Polovni Automobili',
    url: 'https://www.polovniautomobili.com',
    logo: '/logos/polovniautomobili-logo.png',
  },
  {
    name: 'Osiguranik',
    url: 'https://osiguranik.rs',
    logo: '/logos/osiguranik__logo.png',
  },
];

const CompanyLogos: React.FC = () => {
  const isMobile = useIsMobile();
  
  return (
    <div className="w-full">
      <div className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-4 gap-10 sm:gap-12 justify-items-center items-center">
        {companies.map((company, index) => (
          <motion.a
            key={company.name}
            href={company.url}
            target="_blank"
            rel="noopener noreferrer"
            className="w-full flex justify-center"
            initial={{ opacity: 0, y: 32 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.6 }}
            transition={{ delay: 0.08 * index, duration: 0.7, type: 'spring', stiffness: 80 }}
            whileHover={{ scale: 1.08 }}
          >
            <div className="company-logo-glass flex items-center justify-center h-28 w-48 p-5 transition-all duration-300">
              <img
                src={company.logo}
                alt={`Logo ${company.name}`}
                loading="lazy"
                className="max-h-24 max-w-full object-contain"
              />
            </div>
          </motion.a>
        ))}
      </div>
    </div>
  );
};

export default CompanyLogos;
